import React, { FunctionComponent } from 'react';

import {
  Grid
} from '@mui/material';

import {
  Typography
} from '../../interface';

import { BenefitBlock } from '../../../models/BenefitBlock';
import { EmailBlock } from '../../../models/EmailBlock';

type BlockPublicTextProps = {
  block: EmailBlock | BenefitBlock;
  marked: boolean;
  activeLocale: 'nl' | 'fr';
};

export const BlockPublicText: FunctionComponent<BlockPublicTextProps> = ({block, marked, activeLocale}) => {
  let string_value = block.string_value;
  if (typeof(string_value) !== 'string') string_value = (activeLocale === 'nl' ? string_value?.nl : string_value?.fr);

  return ( <Grid xs={12} id={block.id?.toString()} sx={{
    marginTop: block.settings?.mtop || 0,
    marginBottom: block.settings?.mbot || 0,
    border: `1px solid ${block.settings?.border || 'transparent'}`,
    padding: '12px',
    paddingTop: 0,
    paddingBottom: 0,
    ...(!!marked ? {backgroundColor: 'rgba(255, 255, 0, 0.3)'} : {})
  }}>
    {!!string_value && <Typography nw_text html>{string_value}</Typography>}
    {!string_value && <Typography sx={{fontStyle: 'italic', color: 'lightgrey !important'}}>Content goes here...</Typography>}
  </Grid>);
};
